import { ChevronRight } from "@mui/icons-material";
import useRecoveries from "../../../../../../Hooks/useRecoveries";
import Button from "../../../../../UI/GeneralPurpose/Button";

const UIText = {
  "es-CL": { label: "Siguiente" },
  "en-US": { label: "Next" },
};

const Next = () => {
  const request = useRecoveries();
  const recoveries = request.recoveries ?? [];

  return (
    <Button
      {...{
        disabled: recoveries.length === 0,
        UIText,
        navTo: "/dashboard/recovery/step2",
        endIcon: <ChevronRight />,
      }}
    />
  );
};

export default Next;
